const events_en = require('./events.json')
export default events_en